import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { setTimeout } from "timers";
import * as FileSaver from 'file-saver';


class OtherCoverage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            shouldLoadData: true
        };
        this.goToUpdateOtherCoveragePage = this.goToUpdateOtherCoveragePage.bind(this);
        this.goToOtherCoverageDetailsPage = this.goToOtherCoverageDetailsPage.bind(this);
        this.getOtherInsuranceForm = this.getOtherInsuranceForm.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.OtherCoverage.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if ((swhp || hpIdentity) && this.state.shouldLoadData && !isFetching) {
            this.props.getOtherCoverage();
            this.setState({ shouldLoadData: false });
        }

        if (this.props.otherCoverage !== prevProps.otherCoverage || (this.props.error && this.props.error !== prevProps.error && !this.state.shouldLoadData)) {
            this.setState({ showLoader: false, shouldLoadData: false });
        }

        if (this.props.form !== prevProps.form) {
            if (this.props.error || !this.props.form || this.props.form.status === 204) {
                console.log("could not download form");
                return;
            }

            FileSaver.saveAs(this.props.form, "OtherInsuranceSurvey.pdf");
        }
    }

    goToUpdateOtherCoveragePage() {
        this.props.history.push('/updateOtherCoverage');
    }

    goToOtherCoverageDetailsPage(otherCoverage) {
        this.props.history.push('/otherCoverageDetails', { otherCoverage: otherCoverage, swhp: this.props.swhp, hpIdentity: this.props.hpIdentity });
    }

    getOtherInsuranceForm() {
        this.props.getForm("OtherInsuranceSurvey");
    }

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title">Other Coverage</div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="other-coverage-wrapper">
                            <div className="other-coverage-container">
                                {(this.props.swhp || (this.props.hpIdentity && this.props.hpIdentity.roles.includes("ActiveMembers"))) &&
                                    <div className="other-coverage-controls">
                                        <div className={`semi-bold-text control-item ${this.props.hpIdentity ? this.props.hpIdentity.loginOrganization == "FCHP" ? "" : "hidden" : "hidden"}`} onClick={() => this.getOtherInsuranceForm()}>
                                            <span className="icon-messages control-icon"></span>
                                        Update Other Insurance by Mail
                                    </div>
                                    <div className={`semi-bold-text control-item ${this.props.swhp ? "hidden" : ""}`} onClick={() => this.goToUpdateOtherCoveragePage()}>
                                            <span className="icon-new control-icon"></span>
                                            Add Other Coverage
                                        </div>
                                    </div>
                                }
                                <hr className={`${this.props.swhp ? "hidden" : ""}`}></hr>
                                <div className="other-coverage-policy-text">Please be sure to update other insurance coverage for everyone on your policy.</div>
                                {this.state.showLoader ?
                                    <div id="other-coverage-spinner" className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    <div className="other-coverage-content">
                                        {this.props.otherCoverage && this.props.otherCoverage.filter(otherCoverage => otherCoverage.coverageType !== "No Other Insurance").length > 0 ?
                                            this.props.otherCoverage.filter(otherCoverage => otherCoverage.coverageType !== "No Other Insurance").map((otherCoverage) => {
                                                return (
                                                    <div key={otherCoverage.policySystemId ? otherCoverage.policySystemId : otherCoverage.groupNumber} className="row other-coverage-list-item">
                                                        <div className="col-4 other-coverage-list-name">{this.props.hpIdentity ? this.props.hpIdentity.firstName + " " + this.props.hpIdentity.lastName : otherCoverage.subscriberName ? otherCoverage.subscriberName : "N/A"}</div>
                                                        <div className="col-4 other-coverage-list-plan">{otherCoverage.benefitPlanName ? otherCoverage.benefitPlanName : otherCoverage.coverageType ? otherCoverage.coverageType : "Unknown Plan"}</div>
                                                        <div className="col-4 other-coverage-view-link semi-bold-text" onClick={() => this.goToOtherCoverageDetailsPage(otherCoverage)}>VIEW</div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <div className="msg-no-other-coverage">You haven't added other coverage.</div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        error: state.healthPlanServices.error,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        otherCoverage: state.healthPlanServices.otherCoverage,
        form: state.healthPlanServices.form,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOtherCoverage: () => dispatch({ type: types.HP_GET_OTHER_COVERAGE_START }),
        getForm: (formName) => dispatch({ type: types.HP_GET_FORM_START, formName: formName })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OtherCoverage));
